module.exports = __webpack_public_path__ + "static/ACMLocal1-5781e400aeeafaa701ef97d11d4d73a3.jpg";